export default __webpack_public_path__ + "static/media/checker-bg.b0cefccb.jpg";